/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidacyCvDestroyPathParams, CandidacyCvDestroyResponse } from '../types/CandidacyCvDestroy'

/**
 * DELETE /candidate-center/organisations/:organisation/candidacies/:candidacy/cv/:cv
 * @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyCvController.php CandidacyCvController::destroy
 */
export async function candidacyCvDestroy(
	organisation: CandidacyCvDestroyPathParams['organisation'],
	candidacy: CandidacyCvDestroyPathParams['candidacy'],
	cv: CandidacyCvDestroyPathParams['cv'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidacyCvDestroyResponse>> {
	return axiosInstance.delete(
		`/candidate-center/organisations/${organisation}/candidacies/${candidacy}/cv/${cv}`,
		config,
	)
}
